import styled from 'react-emotion';

export const Logo = styled('img')`
  width: 24px;
  height: 24px;
`;
